import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

const getHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

const appointmentService = {
  // Lista con filtros opcionales
  getAll: (params = {}) =>
    axios.get(`${API}/appointments`, { ...getHeaders(), params }),

  // Citas de hoy (para dashboard)
  getToday: () =>
    axios.get(`${API}/appointments/today`, getHeaders()),

  // Detalle
  getById: (id) =>
    axios.get(`${API}/appointments/${id}`, getHeaders()),

  // Crear
  create: (data) =>
    axios.post(`${API}/appointments`, data, getHeaders()),

  // Editar
  update: (id, data) =>
    axios.put(`${API}/appointments/${id}`, data, getHeaders()),

  // Cambiar status
  updateStatus: (id, data) =>
    axios.patch(`${API}/appointments/${id}/status`, data, getHeaders()),

  // Reprogramar
  reschedule: (id, data) =>
    axios.patch(`${API}/appointments/${id}/reschedule`, data, getHeaders()),

  // Eliminar
  delete: (id) =>
    axios.delete(`${API}/appointments/${id}`, getHeaders()),

  getStats: (month, year) =>
    axios.get(`${API}/appointments/stats`, { ...getHeaders(), params: { month, year } }),

  
};

export default appointmentService;